import { useEffect } from "react";
import IDW from "@/components/reports/soil/soil-map/idw";

function SoilMap({ parameterMapInfo, polygonBounds, mapId }) {
  useEffect(() => {
    let container = window.L.DomUtil.get(mapId);
    if (container !== undefined) {
      container._leaflet_id = null;
    }
    if (document.getElementById(mapId) && polygonBounds && parameterMapInfo) {
      new IDW({
        mapDiv: document.getElementById(mapId),
        polygonBounds: polygonBounds,
        imagePath: parameterMapInfo?.mapInfo?.image_path,
        imageBounds: parameterMapInfo?.mapInfo?.image_bounds,
        parameterMapInfo: parameterMapInfo,
      });
    }
  }, [document.getElementById(mapId)]);

  return (
    <div className="w-[685px] h-[435px]" id="mainContainer">
      <div className="w-[685px] h-[435px]" id={mapId}></div>
    </div>
  );
}

export default SoilMap;
